import find from 'lodash/find';
import moment from 'moment';
import { SERVICE_STATUS } from 'views/Microbundle/AddNewMb/constants';

//This method checks if the device is a mobile device.
export const isMobileDevice = () => {
	return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

//This method checks for the status of the microbundle plan additional benefits, and returns trur if the status is active or pending
export const isServiveActiveOrPending = (serviceStatus: string) => {
	const status = serviceStatus?.toLowerCase();
	return (
		status == SERVICE_STATUS.ACTIVE ||
		status == SERVICE_STATUS.PENDING ||
		status == SERVICE_STATUS.PENDING_ACTIVATION
	);
};

export const isServiceActive = (serviceStatus: string) => {
	const status = serviceStatus?.toLowerCase();
	return status == SERVICE_STATUS.ACTIVE;
};

/**
 * Returns a compare function that can be used to sort an array of objects by a given key
 * @param key - The key to sort the array by
 * @param order - The order to sort the array in (asc or desc)
 * @param sortingOrder - An optional object that maps values to their sort order
 * @returns A compare function that can be used to sort an array of objects by the given key
 */
export const compare = (key: any, order = 'asc', sortingOrder: any) => {
	return function compareObjects(obj1: any, obj2: any) {
		// If either object does not have the key, return 0
		if (!obj1.hasOwnProperty(key) || !obj2.hasOwnProperty(key)) return 0;

		// Get the sort order of the values for the given key
		const value1 = obj1[key] in sortingOrder ? sortingOrder[obj1[key]] : Number.MAX_SAFE_INTEGER;
		const value2 = obj2[key] in sortingOrder ? sortingOrder[obj2[key]] : Number.MAX_SAFE_INTEGER;

		// Compare the values and set the result accordingly
		let result = 0;
		if (value1 < value2) result = -1;
		else if (value1 > value2) result = 1;

		// Return the result in the specified order
		return order === 'desc' ? ~result : result;
	};
};

export const findElementWithHighestDate = <T extends { endDate: string }>(arr: T[]): T | undefined =>
	arr.length ? arr.reduce((max, obj) => (moment(obj.endDate).isAfter(moment(max.endDate)) ? obj : max)) : undefined;

export function getValueByKey<T extends { key: string; value: any }>(array: T[], keyName: string): T['value'] | false {
	if (!array) return false;
	const found = find(array, (item) => item.key === keyName);
	return found?.value;
}
